import { conversionToTreeViewItem } from "@helpers/generals";
import { baseApi } from "./baseApi";
import {
    BalanceSheet,
    CashFlow,
    CustomerSupplier,
    CustomerSupplierInvoice,
    Expenditure,
    PalencaData,
    ProductsAndServices,
    ProductService,
    Sale,
} from "@interfaces/syntage";
import {
    CreditBureauInfo,
    CreditBureauInfoRecord,
    CreditDetailRecord,
    InvoicesResponse,
    KPIsModel,
    MatrixRecord,
    ModelDownloadStatus,
    MopStats,
    PaymentCapacity,
    PaymentCapacitySubResponse,
    RpcInfo,
    RugInfo,
} from "@interfaces/model";

import { UUID } from "crypto";
import { Response, ResponsePagination } from "@interfaces/response";
import { ClientSuppliers } from "@interfaces/references";

import IncomeStatement from "../dataDummy/incomeStatement.json";
import MonthlySales from "../dataDummy/monthlySales.json";
import MonthlyExpenditures from "../dataDummy/monthlyExpenditures.json";
import MonthlyCashFlow from "../dataDummy/monthlyCashFlow.json";
import MonthlyCustomerSupplierInvoice from "../dataDummy/monthlyCustomerSupplierInvoice.json";
import MonthlyProductsAnsServices from "../dataDummy/monthlyProductsAnsServices.json";
import BalanceSheetData from "../dataDummy/balanceSheet.json";
import RugInfoData from "../dataDummy/rugInfo.json";
import RPCInfoData from "../dataDummy/rpcInfo.json";
import PalencaInfoData from "../dataDummy/palenca.json";
import TaxKPIsData from "../dataDummy/taxKpis.json";
import InvoiceDetails from "../dataDummy/invoiceDetails.json";
import CreditBureauGeneralData from "../dataDummy/creditBureauGeneralData.json";
import CreditBureauCountCurrentCredits from "../dataDummy/creditBureauCountCurrentCredits.json";
import CreditBureauMopsPercentage from "../dataDummy/creditBureauMopsPercentage.json";
import CreditBureauMopsMetrics from "../dataDummy/creditBureauMopsMetrics.json";
import CreditBureauMatrix from "../dataDummy/creditBureauMatrix.json";
import ModelDownloadStatusData from "../dataDummy/modelDownloadStatus.json";
import AbortiveReviewsStatus from "../dataDummy/abortivesReviewsStatus.json";

const satCore = baseApi.injectEndpoints({
    endpoints: (build) => ({
        postMonthlySales: build.mutation<Array<Sale>, { rfc: string; startDate: string; endDate: string }>({
            // query: ({ rfc, startDate, endDate }) => ({
            //     url: "/sat_core/dashboards/monthly-total-sales-revenue",
            //     method: "POST",
            //     body: {
            //         rfc,
            //         date_from: startDate,
            //         date_to: endDate,
            //     },
            // }),
            // transformResponse: (response: Response<Array<Sale>>) => {
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: MonthlySales,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/monthly-total-sales-revenue`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        date_from: args.startDate,
                        date_to: args.endDate,
                    },
                });

                return result.data;
            },
        }),
        postMonthlyExpenditures: build.mutation<
            Array<Expenditure>,
            { rfc: string; startDate: string; endDate: string }
        >({
            // query: ({ rfc, startDate, endDate }) => ({
            //     url: "/sat_core/dashboards/monthly-total-expenditures",
            //     method: "POST",
            //     body: {
            //         rfc,
            //         date_from: startDate,
            //         date_to: endDate,
            //     },
            // }),
            // transformResponse: (response: Response<Array<Expenditure>>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: MonthlyExpenditures,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/monthly-total-expenditures`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        date_from: args.startDate,
                        date_to: args.endDate,
                    },
                });

                return result.data;
            },
        }),
        postMonthlyCashFlow: build.mutation<Array<CashFlow>, { rfc: string; startDate: string; endDate: string }>({
            // query: ({ rfc, startDate, endDate }) => ({
            //     url: "/sat_core/dashboards/monthly-total-cash-flow",
            //     method: "POST",
            //     body: {
            //         rfc,
            //         date_from: startDate,
            //         date_to: endDate,
            //     },
            // }),
            // transformResponse: (response: Response<Array<CashFlow>>) => {
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: MonthlyCashFlow,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/monthly-total-cash-flow`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        date_from: args.startDate,
                        date_to: args.endDate,
                    },
                });

                return result.data;
            },
        }),
        postMonthlyCustomerSupplierInvoice: build.mutation<
            CustomerSupplierInvoice,
            { rfc: string; startDate: string; endDate: string }
        >({
            // query: ({ rfc, startDate, endDate }) => ({
            //     url: "/sat_core/dashboards/customer-supplier-invoice-concentration",
            //     method: "POST",
            //     body: {
            //         rfc,
            //         date_from: startDate,
            //         date_to: endDate,
            //     },
            // }),
            // transformResponse: (response: Response<CustomerSupplierInvoice>) => {
            //     return {
            //         clients: response.data.clients ?? [],
            //         suppliers: response.data.suppliers ?? [],
            //     };
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: MonthlyCustomerSupplierInvoice,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/customer-supplier-invoice-concentration`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        date_from: args.startDate,
                        date_to: args.endDate,
                    },
                });

                return result.data;
            },
        }),
        postMonthlyProductsAnsServices: build.mutation<
            {
                bought: Array<ProductService>;
                sold: Array<ProductService>;
            },
            { rfc: string; startDate: string; endDate: string }
        >({
            // query: ({ rfc, startDate, endDate }) => ({
            //     url: "/sat_core/dashboards/products-and-services",
            //     method: "POST",
            //     body: {
            //         rfc,
            //         date_from: startDate,
            //         date_to: endDate,
            //     },
            // }),
            // transformResponse: (response: Response<ProductsAndServices>) => {
            //     return {
            //         bought: response.data.bought ?? [],
            //         sold: response.data.sold ?? [],
            //     };
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: MonthlyProductsAnsServices,
                    };
                }
                const result = await baseQuery({
                    url: `/sat_core/dashboards/products-and-services`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        date_from: args.startDate,
                        date_to: args.endDate,
                    },
                });

                return result.data;
            },
        }),
        postBalanceSheet: build.mutation<Array<any>, { rfc: string; startDate: string; endDate: string }>({
            // query: ({ rfc, startDate, endDate }) => ({
            //     url: "/sat_core/dashboards/balance-sheet",
            //     method: "POST",
            //     body: {
            //         rfc,
            //         date_from: startDate,
            //         date_to: endDate,
            //     },
            // }),
            // transformResponse: (response: Response<BalanceSheet>) => {
            //     if (Array.isArray(response.data) || response.data.data?.length === 0) {
            //         return [];
            //     }

            //     return response.data.data.map((item) => conversionToTreeViewItem(item, 0));
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    const tmp = {
                        data: BalanceSheetData.map((item) => conversionToTreeViewItem(item, 0)),
                    };

                    return tmp;
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/balance-sheet`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        date_from: args.startDate,
                        date_to: args.endDate,
                    },
                });

                if (Array.isArray(result.data) || result.data.data.data?.length === 0) {
                    return [];
                }

                return {
                    data: result.data.data.data.map((item) => conversionToTreeViewItem(item, 0)),
                };
            },
        }),
        postIncomeStatement: build.mutation<Array<any>, { rfc: string; startDate: string; endDate: string }>({
            // query: ({ rfc, startDate, endDate }) => ({
            //     url: "/sat_core/dashboards/income-statement",
            //     method: "POST",
            //     body: {
            //         rfc,
            //         date_from: startDate,
            //         date_to: endDate,
            //     },
            // }),
            // transformResponse: (response: Response<Array<any>>) => {
            //     return response.data.data.map((item) => conversionToTreeViewItem(item, 0));
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: IncomeStatement.map((item) => conversionToTreeViewItem(item, 0)),
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/income-statement`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        date_from: args.startDate,
                        date_to: args.endDate,
                    },
                });

                return {
                    data: result.data.data.data.map((item) => conversionToTreeViewItem(item, 0)),
                };
            },
        }),
        postModelDownloadStatus: build.mutation<ModelDownloadStatus, { applicationId: UUID; rfc: string }>({
            // query: ({ applicationId, rfc }) => ({
            //     url: "/sat_core/dashboards/model-status",
            //     method: "POST",
            //     body: {
            //         rfc: rfc,
            //         loan_application_id: applicationId,
            //     },
            // }),
            // transformResponse: (response: Response<ModelDownloadStatus>) => {
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: ModelDownloadStatusData,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/model-status`,
                    method: "POST",
                    body: {
                        rfc: args.rfc,
                        loan_application_id: args.applicationId,
                    },
                });

                return result.data;
            },
        }),
        postRugInfo: build.mutation<Array<RugInfo>, { loanApplicationId: UUID; rfc: string }>({
            // query: (payload) => ({
            //     url: "/sat_core/dashboards/rug-info",
            //     method: "POST",
            //     body: {
            //         loan_application_id: payload.loanApplicationId,
            //         rfc: payload.rfc,
            //     },
            // }),
            // transformResponse: (response: Response<Array<RugInfo>>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: RugInfoData,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/rug-info`,
                    method: "POST",
                    body: args,
                });

                return result.data;
            },
        }),
        postRpcInfo: build.mutation<Response<RpcInfo>, string>({
            // query: (rfc) => ({
            //     url: "/sat_core/dashboards/rpc-info",
            //     method: "POST",
            //     body: {
            //         rfc: rfc,
            //     },
            // }),

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args === "BPP2207121N2") {
                    return {
                        data: RPCInfoData,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/rpc-info`,
                    method: "POST",
                    body: {
                        rfc: args,
                    },
                });

                return result;
            },
        }),
        getActFile: build.query<Response<string>, UUID>({
            query: (fileId) => ({
                url: `/sat_core/dashboards/syntage-file/${fileId}`,
            }),
        }),
        postRetryRunModel: build.mutation<void, any>({
            query: (body) => ({
                url: `/sat_core/run_model`,
                method: "POST",
                body: body,
            }),
        }),
        postRfcInvoices: build.mutation<void, any>({
            query: (body) => ({
                url: "/sat_core/update_rfc_invoices",
                method: "POST",
                body: body,
            }),
        }),
        postCreditBureauReconsultAuth: build.mutation<void, any>({
            query: (body) => ({
                url: "/sat_core/credit_bureau_reconsult_authorization",
                method: "POST",
                body: body,
            }),
        }),
        postPalenca: build.mutation<PalencaData, UUID>({
            // query: (loanApplicationId) => ({
            //     url: "/sat_core/buro_ingresos",
            //     method: "POST",
            //     body: {
            //         loan_application_id: loanApplicationId,
            //     },
            // }),
            // transformResponse: (response: Response<PalencaData>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args === "3912e960-7795-434f-bc47-d277ff43937e") {
                    return {
                        data: PalencaInfoData,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/buro_ingresos`,
                    method: "POST",
                    body: {
                        loan_application_id: args,
                    },
                });

                return result.data;
            },
        }),
        getClientReferences: build.query<Array<ClientSuppliers>, string>({
            query: (params) => ({
                url: `/sat_core/clients_and_suppliers?${params}`,
            }),
            transformResponse: (response: ResponsePagination<ClientSuppliers>) => {
                return response.data.data;
            },
        }),
        postPaymentCapacity: build.mutation<PaymentCapacity, { applicationId: UUID; clientRfc: string }>({
            query: (body) => ({
                url: "/sat_core/payment_capacity",
                method: "POST",
                body: {
                    loan_application_id: body.applicationId,
                    client_rfc: body.clientRfc,
                },
            }),
            transformResponse: (response: Response<PaymentCapacitySubResponse>) => {
                return response.data.data;
            },
        }),
        getTaxKpis: build.query<Array<KPIsModel>, string>({
            // query: (params) => ({
            //     url: `/sat_core/dashboards/tax-return-kpis?${params}`,
            // }),
            // transformResponse: (response: Response<Array<KPIsModel>>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("BPP2207121N2")) {
                    return {
                        data: TaxKPIsData,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/tax-return-kpis?${args}`,
                });

                return result.data;
            },
        }),
        getInvoiceDetails: build.query<InvoicesResponse, string>({
            // query: (params) => ({
            //     url: `/sat_core/dashboards/invoices?${params}`,
            // }),
            // transformResponse: (response: Response<InvoicesResponse>) => {
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("BPP2207121N2")) {
                    return {
                        data: InvoiceDetails,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/dashboards/invoices?${args}`,
                });

                return result.data;
            },
        }),
        getInvoiceFile: build.query<Response<any>, UUID>({
            query: (fileId) => ({
                url: `/sat_core/dashboards/invoice-file/${fileId}`,
            }),
        }),
        // old_getCreditBureauInfo: build.query<Array<CreditBureauInfoRecord>, { applicationId: UUID; params: string }>({
        //     query: ({ applicationId, params }) => ({
        //         url: `/sat_core/bureau_information/${applicationId}?${params}`,
        //     }),
        //     transformResponse: (response: ResponsePagination<CreditBureauInfoRecord>) => {
        //         return response.data.data;
        //     },
        // }),
        getCreditBureauGeneralData: build.query<CreditBureauInfo, string>({
            // query: (params) => ({
            //     url: `/sat_core/bureau/general_data?${params}`,
            // }),
            // transformResponse: (response: Response<CreditBureauInfo>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("BPP2207121N2")) {
                    return CreditBureauGeneralData;
                }

                const result = await baseQuery({
                    url: `/sat_core/bureau/general_data?${args}`,
                });

                return result.data;
            },
        }),
        getCreditBureauCountCurrentCredits: build.query<Record<string, number>, string>({
            // query: (params) => ({
            //     url: `/sat_core/bureau/count_current_credits?${params}`,
            // }),
            // transformResponse: (response: Response<Record<string, number>>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("BPP2207121N2")) {
                    return {
                        data: CreditBureauCountCurrentCredits,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/bureau/count_current_credits?${args}`,
                });

                return result.data;
            },
        }),
        getCreditBureauMopsPercentage: build.query<Record<string, MopStats>, string>({
            // query: (params) => ({
            //     url: `/sat_core/bureau/mops_percentage?${params}`,
            // }),
            // transformResponse: (response: Response<Record<string, MopStats>>) => {
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("BPP2207121N2")) {
                    return {
                        data: CreditBureauMopsPercentage,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/bureau/mops_percentage?${args}`,
                });

                return result.data;
            },
        }),
        getCreditBureauMopsMetrics: build.query<Record<string, Record<string, MopStats>>, string>({
            // query: (params) => ({
            //     url: `/sat_core/bureau/mops_metrics?${params}`,
            // }),
            // transformResponse: (response: Response<Record<string, Record<string, MopStats>>>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("BPP2207121N2")) {
                    return {
                        data: CreditBureauMopsMetrics,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/bureau/mops_metrics?${args}`,
                });

                return result.data;
            },
        }),
        getCreditBureauMatrix: build.query<Array<CreditDetailRecord>, string>({
            // query: (params) => ({
            //     url: `/sat_core/bureau/matrix?${params}`,
            // }),
            // transformResponse: (response: Response<Array<MatrixRecord>>) => {
            //     return response.data.map((record) => ({
            //         contract: record.Contrato,
            //         lenderType: record["Tipo Otorgante"],
            //         currency: record.Moneda,
            //         status: record.Status,
            //         type: record["Tipo Credito"],
            //         code: record["Codigo credito"],
            //         termVsRevolving: record["Simple vs Revolvente"],
            //         detail: record.Detalle,
            //         openingDate: record.Apertura,
            //         closingDate: record.Cierre,
            //         term: record.Plazo,
            //         originalAmount: record.Original,
            //         currentAmount: record.Vigente,
            //         lastUpdatedPeriod: record["Ultimo Periodo Actualizado"],
            //         history: record.Historicos,
            //         maturityDistribution_129: record["1-29 días"],
            //         maturityDistribution_3059: record["30-59 días"],
            //         maturityDistribution_6089: record["60-89 días"],
            //         maturityDistribution_90119: record["90-119 días"],
            //         maturityDistribution_120179: record["120-179 días"],
            //         maturityDistribution_180: record["180+ días"],
            //     }));
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.includes("BPP2207121N2")) {
                    return {
                        data: CreditBureauMatrix.map((record) => ({
                            contract: record.Contrato,
                            lenderType: record["Tipo Otorgante"],
                            currency: record.Moneda,
                            status: record.Status,
                            type: record["Tipo Credito"],
                            code: record["Codigo credito"],
                            termVsRevolving: record["Simple vs Revolvente"],
                            detail: record.Detalle,
                            openingDate: record.Apertura,
                            closingDate: record.Cierre,
                            term: record.Plazo,
                            originalAmount: record.Original,
                            currentAmount: record.Vigente,
                            lastUpdatedPeriod: record["Ultimo Periodo Actualizado"],
                            history: record.Historicos,
                            maturityDistribution_129: record["1-29 días"],
                            maturityDistribution_3059: record["30-59 días"],
                            maturityDistribution_6089: record["60-89 días"],
                            maturityDistribution_90119: record["90-119 días"],
                            maturityDistribution_120179: record["120-179 días"],
                            maturityDistribution_180: record["180+ días"],
                        })),
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/bureau/matrix?${args}`,
                });

                return {
                    data: result.data.data.map((record) => ({
                        contract: record.Contrato,
                        lenderType: record["Tipo Otorgante"],
                        currency: record.Moneda,
                        status: record.Status,
                        type: record["Tipo Credito"],
                        code: record["Codigo credito"],
                        termVsRevolving: record["Simple vs Revolvente"],
                        detail: record.Detalle,
                        openingDate: record.Apertura,
                        closingDate: record.Cierre,
                        term: record.Plazo,
                        originalAmount: record.Original,
                        currentAmount: record.Vigente,
                        lastUpdatedPeriod: record["Ultimo Periodo Actualizado"],
                        history: record.Historicos,
                        maturityDistribution_129: record["1-29 días"],
                        maturityDistribution_3059: record["30-59 días"],
                        maturityDistribution_6089: record["60-89 días"],
                        maturityDistribution_90119: record["90-119 días"],
                        maturityDistribution_120179: record["120-179 días"],
                        maturityDistribution_180: record["180+ días"],
                    })),
                };
            },
        }),
        getAbortivesReviewsStatus: build.query<any, { rfc: string; loanApplicationId: UUID; companyId: UUID }>({
            // query: (params) => ({
            //     url: `/sat_core/abortives-reviews/status`,
            //     params: params,
            // }),
            // transformResponse: (response: Response<any>) => {
            //     return response.data;
            // },
            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args.rfc === "BPP2207121N2") {
                    return {
                        data: AbortiveReviewsStatus,
                    };
                }

                const result = await baseQuery({
                    url: `/sat_core/abortives-reviews/status`,
                    params: args,
                });

                return {
                    data: result.data.data,
                };
            },
        }),
    }),
});

export const {
    usePostMonthlySalesMutation,
    usePostMonthlyExpendituresMutation,
    usePostMonthlyCashFlowMutation,
    usePostMonthlyCustomerSupplierInvoiceMutation,
    usePostMonthlyProductsAnsServicesMutation,
    usePostBalanceSheetMutation,
    usePostIncomeStatementMutation,
    usePostModelDownloadStatusMutation,
    usePostRugInfoMutation,
    usePostRpcInfoMutation,
    useLazyGetActFileQuery,
    usePostRetryRunModelMutation,
    usePostRfcInvoicesMutation,
    usePostCreditBureauReconsultAuthMutation,
    usePostPalencaMutation,
    useLazyGetClientReferencesQuery,
    useGetClientReferencesQuery,
    usePostPaymentCapacityMutation,
    useLazyGetTaxKpisQuery,
    useLazyGetInvoiceDetailsQuery,
    useLazyGetInvoiceFileQuery,
    // old_useLazyGetCreditBureauInfoQuery,
    useLazyGetCreditBureauGeneralDataQuery,
    useLazyGetCreditBureauCountCurrentCreditsQuery,
    useLazyGetCreditBureauMopsMetricsQuery,
    useLazyGetCreditBureauMopsPercentageQuery,
    useLazyGetCreditBureauMatrixQuery,
    useLazyGetAbortivesReviewsStatusQuery,
} = satCore;
